module.exports = __webpack_public_path__ + "static/ShareFileSizeProfile-b381404b78ace97516777429439e1dd8.png";